export default {
    init() {
        // JavaScript to be fired on the front page
    },
    finalize() {
        // JavaScript to be fired on the front page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js